import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import CustomButton from '../../../react-native-material-wrapper/button.component';
import { getTheme } from '../../../../stores/selectors/theme.selector';
import { useSelector } from 'react-redux';
import { sharedStyles } from './shared-styles';
import { DoNotShowAgainCheckbox } from './do-not-show-again-checkbox';
import { PopupProps } from './unlicensed-popup';
import { useTranslation } from 'react-i18next';
const useSpecificStyles = makeStyles(() => ({
  dialogActionRoot: {
    padding: '0px 16px 24px 16px',
  },
  contentTopPadding: {
    padding: '8px 0px 0px 0px',
  },
}));

export const RexelUnlicensedPopup = ({
  doNotShowAgainCheckbox,
  handleCheckboxChange,
  handleClose,
  handleSmartChargingBtnClick,
  open,
  checked,
}: PopupProps) => {
  const { t } = useTranslation();
  const theme = useSelector(getTheme);
  const specificClasses = useSpecificStyles();
  const sharedClasses = sharedStyles();
  const classes = {
    ...sharedClasses,
    ...specificClasses,
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{
        container: classes.container,
        paper: classes.paper,
      }}
    >
      <DialogTitle
        classes={{
          root: clsx(classes.title, classes.XPadding),
        }}
      >
        {t('rexel_unlicensed_charger_popup_heading_1')}
        <DialogContent classes={{ root: classes.contentTopPadding }}>
          <DialogContentText id='dialog-description-1' classes={{ root: classes.contentTextRoot }}>
            {t('rexel_unlicensed_charger_popup_content_1')}
            <span style={{ fontWeight: 700 }}>{t('rexel_unlicensed_charger_popup_content_2')}</span>
            {t('rexel_unlicensed_charger_popup_content_3')}
          </DialogContentText>
        </DialogContent>
      </DialogTitle>
      <DialogActions classes={{ root: classes.dialogActionRoot }}>
        <CustomButton
          variant='contained'
          className={classes.buttonStyles}
          style={{
            backgroundColor: theme.colorPalettes.primary,
            color: '#ffffff',
          }}
          onClick={handleSmartChargingBtnClick}
          disabled={false}
          disableElevation
        >
          {t('unlicensed_charger_popup_btn_1')}
        </CustomButton>
      </DialogActions>
      {doNotShowAgainCheckbox && (
        <DoNotShowAgainCheckbox checked={checked} handleCheckboxChange={handleCheckboxChange} />
      )}
    </Dialog>
  );
};
